import { useState } from 'react';
import { useMacroStore } from '@/store/macroStore';
import { useMacroData } from '@/hooks/useMacroData';
import { trackMacroPickerOpen } from '@/services/gtag';
import { MacroCard } from './MacroCard';
import { MacroPickerModal } from './MacroPickerModal';
import { MacroDetailModal } from './MacroDetailModal';

export function MacroBar() {
  const pinnedSeries = useMacroStore((s) => s.pinnedSeries);
  const detailSeriesId = useMacroStore((s) => s.detailSeriesId);
  const setDetailSeriesId = useMacroStore((s) => s.setDetailSeriesId);

  const [pickerOpen, setPickerOpen] = useState(false);

  // Mount data-fetching logic here (single point in tree)
  useMacroData();

  if (pinnedSeries.length === 0) return null;

  return (
    <>
      <div
        className="flex items-center gap-2 px-3 py-1.5 border-b border-border overflow-x-auto shrink-0"
        style={{
          background: 'var(--glass-header)',
          backdropFilter: 'blur(12px)',
          WebkitBackdropFilter: 'blur(12px)',
        }}
      >
        {/* Cards */}
        {pinnedSeries.map((pinned) => (
          <MacroCard key={pinned.seriesId} pinned={pinned} />
        ))}

        {/* Add more button */}
        <button
          onClick={() => {
            trackMacroPickerOpen('macro_bar');
            setPickerOpen(true);
          }}
          title="Add macro indicator"
          className="flex items-center justify-center w-7 h-7 shrink-0 rounded-full border border-border
            text-muted hover:text-text hover:bg-panel-hover hover:border-accent/40 transition-colors"
        >
          <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
            <line x1="12" y1="5" x2="12" y2="19" /><line x1="5" y1="12" x2="19" y2="12" />
          </svg>
        </button>
      </div>

      {pickerOpen && <MacroPickerModal onClose={() => setPickerOpen(false)} />}

      {detailSeriesId && (
        <MacroDetailModal
          seriesId={detailSeriesId}
          onClose={() => setDetailSeriesId(null)}
        />
      )}
    </>
  );
}
